/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../string-utils/currency.pipe';
import * as import5 from './tip-selection-panel.component';
import * as import6 from '../../ordering-context/ordering-context.model';
import * as import7 from '../../order/order.model';
const styles_TipSelectionPanelComponent:any[] = ([] as any[]);
export const RenderType_TipSelectionPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_TipSelectionPanelComponent,
  data: {}
}
);
function View_TipSelectionPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tip-instructions'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.orderingContextModel.currentStore.tipInstructions || import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.tip.default')));
    ck(v,1,0,currVal_0);
  });
}
function View_TipSelectionPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tip-options-option-no-tip'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.tip.noTip'));
    ck(v,1,0,currVal_0);
  });
}
function View_TipSelectionPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'tip-options-option-percentage'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '%\n            '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_TipSelectionPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tip-options-option-amount'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.calculateTipAmount((<any>v.parent).context.$implicit)));
    ck(v,1,0,currVal_0);
  });
}
function View_TipSelectionPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'tip-options-option'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectTip(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['selected']),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TipSelectionPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TipSelectionPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TipSelectionPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'tip-options-option';
    const currVal_1:any = ck(v,2,0,co.isSelectedTip(v.context.$implicit));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !v.context.$implicit;
    ck(v,5,0,currVal_2);
    const currVal_3:any = v.context.$implicit;
    ck(v,8,0,currVal_3);
    const currVal_4:any = v.context.$implicit;
    ck(v,11,0,currVal_4);
  },(null as any));
}
export function View_TipSelectionPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import4.CurrencyPipe,([] as any[])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'tip'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TipSelectionPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'tip-options'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TipSelectionPanelComponent_2)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.TipSelectionPanelComponent = v.component;
    const currVal_0:any = co.showTipInstructions;
    ck(v,4,0,currVal_0);
    const currVal_1:any = co.tipPercentages;
    ck(v,9,0,currVal_1);
  },(null as any));
}
function View_TipSelectionPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-tip-selection-panel',([] as any[]),(null as any),(null as any),(null as any),View_TipSelectionPanelComponent_0,RenderType_TipSelectionPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import5.TipSelectionPanelComponent,[
      import6.OrderingContextModel,
      import7.OrderModel
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const TipSelectionPanelComponentNgFactory:import0.ComponentFactory<import5.TipSelectionPanelComponent> = import0.ɵccf('woa-tip-selection-panel',import5.TipSelectionPanelComponent,View_TipSelectionPanelComponent_Host_0,{
  tipAmount: 'tipAmount',
  tipSelected: 'tipSelected',
  showTipInstructions: 'showTipInstructions'
}
,{
  tipAmountChange: 'tipAmountChange',
  tipSelectedChange: 'tipSelectedChange'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/payment/tip-selection-panel/tip-selection-panel.component.ngfactory.ts